import styled from "../../../../../client-utils/styled/styled.js";
import shouldForwardProp from "../../../../../client-utils/styled/shouldForwardProp.util.js";
import { SINGLE, SEPTUPLE } from "../../../../../constants/numbers.consts.js";
import Box from "../../../../../components/atoms/Box/index.js";
import ListAtom from "../../../../../components/atoms/List/index.js";
import NavigationRailSubItem from "../../../../../components/molecules/NavigationRail/components/NavigationRailSubItem/index.js";
const coreComponentName = "SdbNavigationRailSub";
export const Root = styled(Box, {
    name: coreComponentName,
    slot: "Root",
    shouldForwardProp: shouldForwardProp("open"),
})(({ open, theme }) => ({
    width: "100%",
    paddingTop: theme.spacing(SEPTUPLE),
    opacity: open ? SINGLE : 0,
    transition: theme.transitions.create("opacity", { delay: theme.transitions.duration.shortest }),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
}));
export const List = styled(ListAtom, {
    name: coreComponentName,
    slot: "List",
})(({ theme }) => ({
    width: "100%",
    overflowY: "auto",
    paddingLeft: theme.spacing(SINGLE),
    paddingRight: theme.spacing(SINGLE),
    scrollbarGutter: "stable both-edges",
}));
export const Item = styled(NavigationRailSubItem, {
    name: coreComponentName,
    slot: "Item",
})();
